module.exports = __webpack_public_path__ + "static/media/foto_parque_tecnologico_sjc.73f5e6df.png";